import { render } from "./DefaultTable.vue?vue&type=template&id=38c19b90"
import script from "./DefaultTable.vue?vue&type=script&lang=js"
export * from "./DefaultTable.vue?vue&type=script&lang=js"
script.render = render

export default script